import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="p-6 text-center">
      <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
      <p className="mb-4 text-muted">The page you are looking for does not exist.</p>
      <Link to="/dashboard" className="text-accent hover:underline">
        Go back home
      </Link>
    </div>
  );
}
